import React from 'react';
import '../styles/PageTemplate.css';

const GetQuote = () => {
  return (
    <div className="page-template">
      <div className="placeholder-content">
        <h1>Get a Free Quote</h1>
        <div className="placeholder-image">
          <p>Quote Request Form Will Appear Here</p>
        </div>
        <div className="placeholder-text">
          <p>Ready to start your project? Fill out our quote request form and we'll get back to you soon.</p>
          <p>This feature is coming soon. Please check back later or contact us directly.</p>
        </div>
      </div>
    </div>
  );
};

export default GetQuote;
